import React from 'react';

export default function TimerText({ currentSeconds, goalSeconds, goalReached = false }) {

  function format(sec) {
    const m = Math.floor(sec / 60).toString().padStart(2, '0');
    const s = Math.floor(sec % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  }

  const currentFormatted = format(currentSeconds);
  const goalFormatted = goalSeconds > 0 ? format(goalSeconds) : "—";

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        textAlign: 'center',
        pointerEvents: 'none',
        textShadow: '0 0 8px rgba(0,0,0,0.6)'
      }}
    >
      <div style={{ fontSize: '22px', fontWeight: 600, letterSpacing: '0.03em' }}>
        {currentFormatted}
      </div>

      <div style={{ fontSize: '13px', opacity: 0.7, marginTop: 2, display: 'flex', alignItems: 'center', gap: '4px' }}>
        / {goalFormatted}
        {goalReached && <span style={{ fontSize: '14px' }}>✅</span>}
      </div>
    </div>
  );
}
